<template>
  <div class="echarts" id="rightEcarts"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  inject,
  watchEffect,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { carFlow } from "@/api/dataAnalysis/carAnalysis.js";
import moment from "moment";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: {
        echartsX: [],
        echartsY: [],
      },
    });
    const refData = toRefs(data);
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          rightEcarts();
        });
      }
    });
    const numberall = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
        startDate: moment(new Date().getTime() - 3600 * 1000 * 24 * 30).format(
          "YYYY-MM-DD 00:00:00"
        ),
        endDate: moment(new Date()).format("YYYY-MM-DD 23:59:59"),
      };
      const res = await carFlow(param);
      res.data.forEach((element) => {
        data.echartsList.echartsX.push(element.name);
        data.echartsList.echartsY.push(element.value);
      });
    };
    const numberallData = async () => {
      const getYM = (num) => {
        const year = new Date().getFullYear();
        const month = new Date().getMonth() + 1;
        console.log(month + num);
        if (!(month + num > 0)) {
          return year - 1 + "-" + (month + 12 + num);
        } else {
          return year + "-" + (month + num);
        }
      };
      const regionObj = {
        15199: [
          { name: getYM(-5), value: "953" },
          { name: getYM(-4), value: "1320" },
          { name: getYM(-3), value: "896" },
          { name: getYM(-2), value: "963" },
          { name: getYM(-1), value: "1200" },
          { name: getYM(0), value: "978" },
        ], //'云峰街道'
        15192: [
          { name: getYM(-5), value: "903" },
          { name: getYM(-4), value: "1020" },
          { name: getYM(-3), value: "796" },
          { name: getYM(-2), value: "1063" },
          { name: getYM(-1), value: "1300" },
          { name: getYM(0), value: "778" },
        ], //'汉丰街道'
        15203: [
          { name: getYM(-5), value: "703" },
          { name: getYM(-4), value: "1220" },
          { name: getYM(-3), value: "896" },
          { name: getYM(-2), value: "1063" },
          { name: getYM(-1), value: "1000" },
          { name: getYM(0), value: "978" },
        ], //'文峰街道'
      };
      console.log(regionInfo.regionList.toString());
      let list = regionObj[regionInfo.regionList.toString()];
      if (!regionInfo.regionList.toString()) {
        list = [
          { name: getYM(-5), value: "2559" },
          { name: getYM(-4), value: "3560" },
          { name: getYM(-3), value: "2588" },
          { name: getYM(-2), value: "3089" },
          { name: getYM(-1), value: "3500" },
          { name: getYM(0), value: "2743" },
        ];
      }
      list.forEach((element) => {
        data.echartsList.echartsX.push(element.name);
        data.echartsList.echartsY.push(element.value);
      });
    };
    let myhouseecharts;
    // color: ['#3d8eb7', '#5dc8d8', '#ecab3c', '#ded747', '#67c99c', '#97b939'],
    const colorList = ["#ffcd00", "#32aaf3"];
    const rightEcarts = async () => {
      data.echartsList.echartsX = [];
      data.echartsList.echartsY = [];
      // await numberall();
      await numberallData();
      myhouseecharts = echarts.init(document.getElementById("rightEcarts"));
      const option = {
        // backgroundColor: '#fff',
        legend: {
          icon: "circle",
          top: "5%",
          right: "10%",
          itemWidth: 6,
          itemGap: 20,
          textStyle: {
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              show: true,
              backgroundColor: "#fff",
              color: "#fff",
              borderColor: "rgba(0,0,0,0)",
              shadowColor: "rgba(0,0,0,0)",
              shadowOffsetY: 0,
            },
            lineStyle: {
              width: 0,
            },
          },
          backgroundColor: "#fff",
          textStyle: {
            color: "#5c6c7c",
          },
          padding: [10, 10],
          extraCssText: "box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)",
        },
        grid: {
          top: "15%",
        },
        xAxis: [
          {
            type: "category",
            data: data.echartsList.echartsX,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#fff",
              },
              // 默认x轴字体大小
              fontSize: 12,
              // margin:文字到x轴的距离
              margin: 15,
            },
            axisPointer: {
              label: {
                // padding: [11, 5, 7],
                padding: [0, 0, 10, 0],
                /*
    除了padding[0]建议必须是0之外，其他三项可随意设置

    和CSSpadding相同，[上，右，下，左]

    如果需要下边线超出文字，设左右padding即可，注：左右padding最好相同

    padding[2]的10:

    10 = 文字距下边线的距离 + 下边线的宽度

    如：UI图中文字距下边线距离为7 下边线宽度为2

    则padding: [0, 0, 9, 0]

                */
                // 这里的margin和axisLabel的margin要一致!
                margin: 15,
                // 移入时的字体大小
                fontSize: 12,
                backgroundColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#32aaf3", // 0% 处的颜色
                    },
                    {
                      // offset: 0.9,
                      offset: 0.86,
                      /*
0.86 = （文字 + 文字距下边线的距离）/（文字 + 文字距下边线的距离 + 下边线的宽度）

                        */
                      color: "#fff", // 0% 处的颜色
                    },
                    {
                      offset: 0.86,
                      color: "#33c0cd", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#33c0cd", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "抓拍次数",
            type: "line",
            data: data.echartsList.echartsY,
            symbolSize: 1,
            symbol: "circle",
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 3,
              // shadowColor: 'rgba(61,190,135, 0.3)',
              // shadowBlur: 10,
              // shadowOffsetY: 20
            },
            itemStyle: {
              normal: {
                color: colorList[0],
                borderColor: colorList[0],
              },
            },
          },
        ],
      };

      //   option && data.myChart.setOption(option);
      //   data.myChart.on('click', function(params) {
      //     context.emit('dialogSate', true); ;
      //   });
      // };
      myhouseecharts.setOption(option);
    };
    onMounted(() => {
      window.addEventListener("resize", () => {
        myhouseecharts.resize();
      });
    });

    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
#rightEcarts {
  width: 100%;
  height: 90%;
}
</style>
